import React from "react";
import Button from "../../../Elements/Button/Button";
import Display from "../../../Elements/Display/Display";
import styles from "../../../Styles/Modules/BetSelector.module.scss";
import { FaMinus, FaPlus } from "react-icons/fa";
import { useSelector } from "react-redux";
import {
  decrementBet,
  incrementBet,
} from "../../../State/Slices/gameSettingsSlice";

const BetSelector = () => {
  // useSelector is a hook from react-redux that allows you to extract data from the Redux store state.
  // Here, it extracts the 'bet' and 'bets' from the 'game' slice of the state.
  const { bet, bets } = useSelector((state) => state.game);

  // Finds the index of the current bet in the bets array.
  const currentIndex = bets.indexOf(bet);

  // Determines if the bet can be incremented by checking if the current index is less than the last index of the bets array.
  const canIncrement = currentIndex < bets.length - 1;

  // Determines if the bet can be decremented by checking if the current index is greater than zero.
  const canDecrement = currentIndex > 0;

  return (
    <div className={styles.betSelector}>
      {/* Button component to decrement the bet.
          - action: Calls the decrementBet function when clicked.
          - title: Sets the button's title attribute to "decrement".
          - icon: Uses the FaMinus icon from react-icons.
          - disabled: Disables the button if canDecrement is false.
          - modifier: Adds a specific class for styling purposes. */}
      <Button
        action={() => decrementBet()}
        title="decrement"
        icon={FaMinus}
        disabled={!canDecrement}
        modifier="buttonDecrement"
      />

      {/* Display component to show the current bet value.
          - value: The current bet value to be displayed.
          - modifier: Adds a specific class for styling purposes. */}
      <Display value={bet} modifier="displayBetSelect" />

      {/* Button component to increment the bet.
          - action: Calls the incrementBet function when clicked.
          - title: Sets the button's title attribute to "increment".
          - icon: Uses the FaPlus icon from react-icons.
          - disabled: Disables the button if canIncrement is false.
          - modifier: Adds a specific class for styling purposes. */}
      <Button
        action={() => incrementBet()}
        title="increment"
        icon={FaPlus}
        disabled={!canIncrement}
        modifier="buttonIncrement"
      />
    </div>
  );
};

export default BetSelector;
